export default __webpack_public_path__ + "static/dashboard-mobile-ebbdf192538a060bf4f08738e9e86ce3.svg";